"use client";

import type { ReactNode } from "react";

import { SupabaseProvider } from "@/components/supabase-provider";

export function RouteAuthProvider({ children }: { children: ReactNode }) {
  return <SupabaseProvider initialUser={null}>{children}</SupabaseProvider>;
}
